import React from "react";
import API from "../lib/TimeEditAPI";
import _ from "underscore";
import Language from "../lib/Language";

/** One of the dialog's own buttons, as presentModal's callers describe them. */
type TModalDialogButton = {
    title: string;
    /** Called instead of the default close when the button is pressed. */
    cb?: (...args: any[]) => void;
    /** Whether pressing it records the "do not show again" choice. */
    remember?: boolean;
    value?: boolean;
};

type TModalDialogProps = {
    onClose: () => void;
    /** The buttons to show, or "NO_BUTTONS" for a dialog that closes itself. */
    buttons?: TModalDialogButton[] | "NO_BUTTONS" | null;
    okButtonTitle?: string | null;
    title?: string | null;
    /** Keys the "do not show again" preference; the checkbox only shows with one. */
    displayKey?: string | null;
    /** Called when the dialog is dismissed with that checkbox ticked. */
    onRemember?: () => void;
    useContentSize?: boolean;
    hasCopyButton?: boolean;
    isModernStyle?: boolean;
    style?: React.CSSProperties;
    onDragStart?: React.DragEventHandler<HTMLDivElement>;
    children?: React.ReactNode;
};

class ModalDialog extends React.Component<TModalDialogProps> {
    state = {
        neverShow: false,
    };

    toggleNeverShow = () => {
        this.setState({ neverShow: !this.state.neverShow });
    };

    onClose = (remember: boolean | React.MouseEvent = true, value = true) => {
        if (this.state.neverShow && remember === true) {
            this.props.onRemember?.();
            API.setPreferences(`dismissedModalDialogs.${this.props.displayKey}`, [value], _.noop);
        }
        this.props.onClose();
    };

    getOkButton = (title) => (
        <button
            className={`deprecated ${
                this.props.isModernStyle === true ? "modernButton" : "save xWide"
            }`}
            onClick={this.onClose}
        >
            {title ? title : Language.get("nc_dialog_done")}
        </button>
    );

    useButtonCallback =
        (cb = _.noop, remember = true, value = true) =>
        () => {
            cb();
            this.onClose(remember, value);
        };

    copyToClipboard = () => {
        window.getSelection()?.selectAllChildren(this.refs.contentArea as unknown as Node);
        document.execCommand("copy");
    };

    render() {
        let neverShowAgainButton: React.JSX.Element | null = null;
        if (this.props.displayKey) {
            neverShowAgainButton = (
                <div className="neverShowAgain">
                    <input type="checkbox" onChange={this.toggleNeverShow} />
                    {Language.get("nc_modal_do_not_show_again")}
                </div>
            );
        }

        let btn: React.JSX.Element | React.JSX.Element[] = this.getOkButton(
            this.props.okButtonTitle
        );
        if (this.props.buttons && this.props.buttons !== "NO_BUTTONS") {
            btn = this.props.buttons.map(this._renderButtons);
        }

        let title: React.JSX.Element | null = null;
        if (this.props.title) {
            title = <h1 draggable="true">{this.props.title}</h1>;
        }

        const copyButton = null;
        /* this.props.hasCopyButton === true ? (
                <button className="dialogCopyButton" onClick={this.copyToClipboard}>
                    {Language.get("cal_res_below_copy")}
                </button>
            ) : null*/

        let style = this.props.useContentSize
            ? "contentModalDialog modal draggableDialog"
            : "modalDialog modal draggableDialog";

        if (this.props.isModernStyle === true) {
            style = `${style} modernStyle`;
        }
        return (
            <div className={style} style={this.props.style} onDragStart={this.props.onDragStart}>
                {title}
                <div className="content">
                    <span ref="contentArea">{this.props.children}</span>
                    {copyButton}
                </div>
                {this.props.buttons === "NO_BUTTONS" ? null : (
                    <div className="buttons btnGroup horizontal paddedButtons">
                        {neverShowAgainButton} {btn}
                    </div>
                )}
            </div>
        );
    }

    _renderButtons = (button: TModalDialogButton) => {
        const className = this.props.isModernStyle === true ? "modernButton" : "save xWide";
        if (button.cb || button.remember !== undefined) {
            return (
                <button
                    className={`deprecated ${className}`}
                    key={`btn_${button.title}`}
                    onClick={this.useButtonCallback(button.cb, button.remember, button.value)}
                >
                    {" "}
                    {button.title}{" "}
                </button>
            );
        }
        return (
            <button
                className={`deprecated ${className}`}
                key={`btn_${button.title}`}
                onClick={this.onClose}
            >
                {" "}
                {button.title}{" "}
            </button>
        );
    };
}

export default ModalDialog;
